import { setMode } from "@stencil/core";

/**
 * This will check the url to get the branding, if the branding is not in the URL it will use the else case
 * If you are on local you will need to change the else case here and in helperFunctions.ts
 */
setMode(() => {
    const hostname = window.location.hostname;
    if (hostname.includes("localhost")) {
        const port = window.location.port;
        if (port.includes("8087") || port.includes("8093")) {
            return "chevrolet";
        } else if (port.includes("8083") || port.includes("8091")) {
            return "buick";
        } else if (port.includes("8082") || port.includes("8094")) {
            return "gmc";
        } else if (port.includes("8081") || port.includes("8092")) {
            return "cadillac";
        } else {
            return "chevrolet";
        }
    } else {
        if (hostname.toLowerCase().includes("chevrolet")) {
            return "chevrolet";
        } else if (hostname.toLowerCase().includes("buick")) {
            return "buick";
        } else if (hostname.toLowerCase().includes("gmc")) {
            return "gmc";
        } else if (hostname.toLowerCase().includes("cadillac")) {
            return "cadillac";
        } else {
            return "chevrolet";
        }
    }
});
